import '@gouch/to-title-case';
import { elements, mqList } from './base';
import { animateInView, highlightInView } from './animation';
import { collapseMainNav, addActiveClass } from './mainNavigation';
// import {
//   renderHomeWorks
// } from "./Home";
import SubNavigation from './SubNavigation';

export function run() {
  const { worksContainer, subNavigation, secondaryHeadings, sectionNums } =
    elements;

  // Render works on the index.html
  // if (worksContainer) renderHomeWorks();
  // Render Sub-navigation on each project page
  if (subNavigation) SubNavigation();

  // Transform the secondary headings to title case
  if (secondaryHeadings) {
    secondaryHeadings.forEach((secondaryHeading) => {
      secondaryHeading.textContent = secondaryHeading.textContent.toTitleCase();
    });
  }

  // When the width of screen is less than 900px
  if (mqList.medLarge.matches) {
    sectionNums.forEach((sectionNum) => {
      if (sectionNum.innerHTML === '&nbsp;') sectionNum.style.display = 'none';
    });
  }

  // Navigation Behavior
  collapseMainNav();
  addActiveClass();

  // Fade-in on scroll
  animateInView();

  // Highlight on scorll
  highlightInView();
}
